import { BoardColumn } from '../board-v3.types';

export const BOARD_V3_DELETE_DROP_ZONE_ID = 'board-v3-drag-action-delete';

const DRAG_ACTION_DROP_ZONE_PREFIX = 'board-v3-drag-action-';

export function boardV3DragActionDropZoneId(column: BoardColumn, hasMultipleFailedColumns: boolean): string {
  if (column.type === 'FAILED' && hasMultipleFailedColumns) {
    return DRAG_ACTION_DROP_ZONE_PREFIX + 'failed';
  }

  return DRAG_ACTION_DROP_ZONE_PREFIX + column.id;
}

export function boardV3VisibleDragActionColumns(columns: BoardColumn[]): BoardColumn[] {
  const failedColumns = columns.filter(column => column.type === 'FAILED');
  const successColumns = columns.filter(column => column.type === 'SUCCESS');
  const firstFailedColumn = failedColumns[0];

  return [
    ...(firstFailedColumn ? [firstFailedColumn] : []),
    ...successColumns,
  ];
}

export function boardV3DragActionDropZoneIds(columns: BoardColumn[]): string[] {
  const hasDragActionColumns = columns.some(column => column.type === 'SUCCESS' || column.type === 'FAILED');
  if (!hasDragActionColumns) return [];

  const failedColumnsCount = columns.filter(column => column.type === 'FAILED').length;
  const hasMultipleFailedColumns = failedColumnsCount > 1;

  return [
    BOARD_V3_DELETE_DROP_ZONE_ID,
    ...boardV3VisibleDragActionColumns(columns).map(column =>
      boardV3DragActionDropZoneId(column, hasMultipleFailedColumns),
    ),
  ];
}
